import React from 'react';
import {Card, CardBody, CardImg, CardTitle, Col} from "reactstrap";
import image from "../../../assets/img/logo-rasad.png"

const CategoriesCards = (props) => {
    const data = props.data
    return (
        <>
            {
                data && data.map((cat, index) => (
                    <Col className="pointer" sm={3} onClick={()=>props.onSelect(cat.id)} key={index}>
                        <Card className="category-card">
                            <CardImg top width="50%" src={image} alt="Card image cap" className={"mx-auto category-icon"}/>
                            <CardBody className={"text-center"}>
                                <CardTitle tag="h5">{cat.title}</CardTitle>
                            </CardBody>
                        </Card>
                    </Col>
                ))
            }
        </>
    )
};

export default CategoriesCards;